export default {"src":"/_next/static/media/ethereum.4a372106.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};